module.exports = __webpack_public_path__ + "ef47dfdb7c0c0c25acdf14212ac1e82e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_tina_mobile_teaser.jpg
// module id = 678
// module chunks = 0